export default "__VITE_ASSET__1a_jOig9__"